"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _OrderBookComponent = _interopRequireDefault(require("./OrderBookComponent"));
var _orderHistoryActions = require("../../redux/actions/orderHistoryActions");
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _level2Selectors = require("../../redux/selectors/level2Selectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _orderHistorySelectors = require("../../redux/selectors/orderHistorySelectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var makeMapStateToProps = function makeMapStateToProps() {
  var openOrdersSelector = (0, _orderHistorySelectors.openOrdersSelectorFactory)();
  return function (state) {
    var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    var fetching = state.apexCore.level2.fetching;
    var decimalPlaces = state.apexCore.product.decimalPlaces;
    var filter = {
      filterMode: 'selectedInstrument'
    };
    var level2 = (0, _level2Selectors.level2Selector)(state, filter);
    var openOrders = openOrdersSelector(state, filter);
    var buyOpenOrders = (0, _orderHistorySelectors.buyOpenOrdersSelector)(state, filter);
    var sellOpenOrders = (0, _orderHistorySelectors.sellOpenOrdersSelector)(state, filter);
    var spread = (0, _level2Selectors.spreadSelector)(state, filter);
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement);
    var convertedPriceIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement);
    return {
      level2: level2,
      spread: (0, _numberFormatter.formatNumberToLocale)(spread, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)),
      decimalPlaces: decimalPlaces,
      fetching: fetching,
      selectedInstrumentId: selectedInstrumentId,
      openOrders: openOrders,
      buyOpenOrders: buyOpenOrders,
      sellOpenOrders: sellOpenOrders,
      selectedInstrument: selectedInstrument,
      convertedQuantityIncrement: convertedQuantityIncrement,
      convertedPriceIncrement: convertedPriceIncrement
    };
  };
};
var mapDispatchToProps = {
  cancelAllOrders: _orderHistoryActions.cancelAllOrders,
  cancelBuyOrders: _orderHistoryActions.cancelBuyOrders,
  cancelSellOrders: _orderHistoryActions.cancelSellOrders,
  cancelOrders: _orderHistoryActions.cancelOrders,
  buyQuantityClicked: _orderEntryActions.buyQuantityClicked,
  buyPriceClicked: _orderEntryActions.buyPriceClicked,
  sellQuantityClicked: _orderEntryActions.sellQuantityClicked,
  sellPriceClicked: _orderEntryActions.sellPriceClicked
};
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_OrderBookComponent["default"]);